import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Stack } from '@mantine/core';
import { FieldConfig } from '../types';
import FieldItem from './FieldItem';

type FieldListProps = {
  fields: FieldConfig[];
  onToggleFieldVisible: (index: number) => void;
  onFieldLabelChange: (index: number, label: string | null) => void;
};

export default function FieldList({
  fields,
  onToggleFieldVisible,
  onFieldLabelChange,
}: FieldListProps) {
  const fieldIds = fields.map(f => f.entityFieldName);

  return (
    <SortableContext items={fieldIds} strategy={verticalListSortingStrategy}>
      <Stack gap={0}>
        {fields.map((field, index) => (
          <FieldItem
            key={field.entityFieldName}
            field={field}
            onToggleVisible={() => onToggleFieldVisible(index)}
            onLabelChange={label => onFieldLabelChange(index, label)}
          />
        ))}
      </Stack>
    </SortableContext>
  );
}
